import React from "react";
import { AboutAuthorProps } from "@/types/modules/author/components";
import { FollowButton } from "@/components/ui-kit/Buttons/FollowButton";
import { RecommendedAuthors } from "@/components/modules/Author/RecommendedAuthors";

export const AboutAuthor: React.FC<AboutAuthorProps> = ({ author }) => {
  return (
    <div className="border-t border-dark">
      <RecommendedAuthors author={author} />
      {/*<div className="font-sans py-2 flex items-center justify-between border-b border-dark">
        <div className="flex flex-col">
          <span className="text-sm">{followingTitle}</span>
          <p className="text-sm font-light">{followingDesc}</p>
        </div>
        <FollowButton />
      </div>*/}
      {author?.shortDescription && (
        <div className="py-4">
          <p className="mt-2 font-sans font-light dark:text-white">{author.shortDescription}</p>
        </div>
      )}
    </div>
  );
};
